import React from 'react'

import yamadumiAuth from '../../Auth'
import { useUnsafeOnceCall } from '../../components/hooks'
import { AuthenticateProgress } from './AuthenticateProgress'

export default function Login() {
  const [error, setError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')
  const onceCall = useUnsafeOnceCall()

  React.useEffect(() => {
    // React.StrictModeでは、開発環境においてコンポーネントを２回マウントする。
    // そのとき、以下の認証処理も２回呼ばれてしまい、
    // ２回目が必ずエラーになってしまう。
    // それを回避するために、１回だけ呼び出すようにしている。
    // （２回目がエラーになってしまうと、トークンのリフレッシュができなくなる）
    onceCall(() => {
      yamadumiAuth.requestAuthentication()
        .catch((error: Error) => {
          setError(true)
          setErrorMessage(error.message)
        })
    })
  })

  return <AuthenticateProgress
    message={error ? 'ログイン処理中にエラーが発生しました' : 'ログイン処理中です...'}
    subMessage={errorMessage}
    returnToHomeButton={error} />
}
